/**
 * Sheet — 모바일 바텀 시트의 공용 부품 두 개.
 *
 * 시트 셸 자체는 페이지가 만든다(시장 이슈 .mk-sheet 는 데스크톱에서
 * display:contents 로 사라지고, 버핏 .bfx-side 는 데스크톱에선 일반 컬럼 —
 * 셸의 정체가 페이지마다 달라 셸까지 원자로 묶으면 억지가 된다).
 * 여기서 묶는 건 **모든 시트가 똑같이 갖는 것**: 그래버(드래그 팔로우 닫기)와
 * 딤(탭하면 닫기). 시장 이슈·버핏에 복붙돼 있던 두 벌을 걷어낸 것 (2026-08-19).
 *
 * 클래스는 프롭으로 받아 기존 CSS(mk-grab·bfx-grab / mk-dim·bfx-dim)를 그대로
 * 소비한다 — 치환은 화면 1px 불변이 규칙. 새 시트를 만들 땐 그 화면의 CSS 에
 * 같은 역할의 클래스를 만들고 여기 물린다.
 */
import { useSheetDrag } from "../lib/sheetDrag";

export interface SheetGrabberProps {
  /** 시트 루트 셀렉터 — 그래버에서 closest 로 찾는다 (".mk-sheet" 등) */
  sheetSelector: string;
  /** 닫기 — 여러 번 불려도 안전해야 한다 */
  onClose: () => void;
  /** 기존 시트의 그래버 클래스 ("mk-grab" · "bfx-grab") */
  className: string;
}

/** 시트 상단 알약 손잡이 — 탭 = 닫기, 드래그 = 손가락 따라오다 110px+ 에서 닫기 */
export function SheetGrabber({ sheetSelector, onClose, className }: SheetGrabberProps) {
  const drag = useSheetDrag(sheetSelector, onClose);
  return (
    <button
      type="button"
      className={className}
      aria-label="닫기"
      onClick={onClose}
      {...drag}
    />
  );
}

export interface SheetDimProps {
  onClose: () => void;
  /** 기존 딤 클래스 ("mk-dim" · "bfx-dim") — 표시 여부는 페이지 CSS 상태가 정한다 */
  className: string;
}

/** 시트 뒤 어두운 막 — 탭하면 닫힌다. touch-action 은 각 클래스 CSS 가 막는다 */
export function SheetDim({ onClose, className }: SheetDimProps) {
  return <div className={className} onClick={onClose} aria-hidden="true" />;
}
